import requestJson from '@/utils/requestJson'

export function prizeLifeSciences(data) {
  return requestJson({
    url: `/form_isboss`,
    method: 'POST',
    data
  })
}


// export function link() {
//   return requestJson({
//     url: `http://wx.oauth.synconize.com/wechat/oauth/?appId=wxfb99f0fc1ca20ac0&redirectUrl=http://192.168.0.134:8080/`,
//     method: 'POST'
//   })
// }
